<form (submit)="onSubmit()" class="step-form" #stepForm>
  @if (headlineTextkey) {
    <div class="grid-x grid-margin-x headline-wrapper">
      <div class="cell small-12 large-offset-1 large-10"><hr></div>
      <div class="cell small-12 large-offset-1 large-10 text-center">
        <h1 [innerHTML]="headlineTextkey | translate"></h1>
      </div>
      <div class="cell small-12 large-offset-1 large-10"><hr></div>
    </div>
  }

  <div  class="grid-x grid-margin-x">
    @if (hasHelp) {
      <div class="cell small-12 medium-5 large-4 medium-order-2 help-wrapper">
        <a class="help-toggle hide-for-medium" (click)="togglePageHelp()">{{(showPageHelp? 'step.help.toggle.close' : 'step.help.toggle.show') | translate}} <i [class]="showPageHelp? 'icon-x-circle' : 'icon-info'"></i></a>
        @if (helpTextkey) {
          <div  class="callout lighter-gray step-help" [class.show]="showPageHelp">
            <div [innerHTML]="helpTextkey | translate"></div>
            @if (hasInlineHelp) {
              <a (click)="toggleInlineHelp()" class="show-for-medium"><i class="icon-help-circle"></i> {{'step.help.more' | translate}}</a>
            }
          </div>
        }
      </div>
    }
    <div class="cell small-12 medium-7 large-offset-2 large-5 medium-order-1" #formWrapper>
      @for (device of devices; track device; let deviceIndex = $index) {
        <div class="device device-{{deviceIndex}}">
          <h2 class="background" [innerHTML]="deviceDescription(deviceIndex)"></h2>
          @for (field of device; track field) {
            @if (field.isActive()) {
              <div formfield
                [invalidIfEmpty]="false" [inlineHelp]="true" [showInlineHelp]="showInlineHelp" [form]="form"
                [formModel]="field" [formConfig]="formConfig" [step]="'stancheck'"
                class="formfield {{field.type}} {{field.classes}}"
                [class.affected-field]="isAffectedFieldForError(deviceIndex, field)"
              ></div>
            }
          }
          @if (deviceIndex > 0 && deviceIndex === devices.length - 1) {
            <a class="button hollow alert large" (click)="removeDevice(deviceIndex)">{{'stancheck.geraet.delete.button' | translate}}</a>
          }
        </div>
      }

      @if(devices.length <= MAX_DEVICES) {
        <div class="callout new-device">
          <p [innerHTML]="'stancheck.geraet.add.teaser' | translate"></p>
          <a class="button" [class.disabled]="!form.valid" (click)="addDevice()"><i class="icon-plus-circle"></i> {{'stancheck.geraet.add.button' | translate}}</a>
        </div>
      }

    </div>
  </div>

  <app-step-buttons [previousLink]="previousStep? previousStep.path : null" [nextLink]="steps?.nextStep? steps.nextStep.path : null" [nextDisabled]="!form.valid" [nextClass]="loadingData? 'loading' : ''"></app-step-buttons>
</form>
